import React from 'react';
import PropTypes from 'prop-types';
import { Label, Flex, Text, FileInput, Toast } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import S from './Uploader.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ACCEPTED_MIME_TYPES = ['text/csv', 'text/tsv', 'text/tab-separated-values', 'application/vnd.ms-excel'];
const ACCEPTED_EXTENSIONS = ['.csv', '.tsv'];
const {
  t
} = I18N.ns('molten.imagine.forms.Uploader');
export default class Uploader extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    eventData: PropTypes.string
  };
  static defaultProps = {
    onChange: () => {},
    eventData: 'csv'
  };
  onCSVSelect = async evt => {
    const {
      onChange,
      eventData,
      onClose
    } = this.props;
    const file = evt?.value[0];
    const type = file.type;
    if (!ACCEPTED_MIME_TYPES.includes(type)) {
      Toast.error(t('error'));
      onClose();
      return;
    }
    const result = await file.text();
    if (typeof onChange === 'function') {
      onChange({
        data: eventData,
        value: {
          result,
          fileName: file.name
        }
      });
    }
  };
  render() {
    const {
      fileName,
      eventData
    } = this.props;
    return /*#__PURE__*/_jsxs(Flex, {
      variant: "colS",
      className: S.container,
      children: [/*#__PURE__*/_jsx(Label, {
        variant: "inputTitle",
        children: t('title')
      }), /*#__PURE__*/_jsxs(Flex, {
        variant: "rowM",
        align: "center",
        className: S.input,
        children: [/*#__PURE__*/_jsx(FileInput, {
          variant: "secondary",
          eventData: eventData,
          fileTypes: ACCEPTED_EXTENSIONS,
          onChange: this.onCSVSelect,
          children: t('input')
        }), fileName && /*#__PURE__*/_jsx(Text, {
          variant: "body",
          className: S.fileName,
          children: fileName
        })]
      })]
    });
  }
}